import tw from '@/tailwind/tailwind'

import { VoteButtonStatusType } from '../types'

export const getHighlightColorFromVote = (vote: VoteButtonStatusType) =>
    vote === 'like' ? tw.color('pc-success') : tw.color('pc-warning')
